import React from 'react';
import Image from '@wix/thunderbolt-elements/src/components/Image/viewer/Image';
import styles from './style/FastGalleryImageRenderer.scss';
import classNames from 'clsx';
import type { ImageRendererProps, Point } from '@wix/fast-gallery-library';

interface FastGalleryImageRendererProps {
  itemData: ImageRendererProps;
}
const DEFAULT_POINT = 50;
const DEFAULT_FOCAL_POINT = {
  x: DEFAULT_POINT,
  y: DEFAULT_POINT,
};

const getFocalPoint = (focalPoint: Point = DEFAULT_FOCAL_POINT) => {
  return {
    x: focalPoint?.x * 100 || DEFAULT_POINT,
    y: focalPoint?.y * 100 || DEFAULT_POINT,
  };
};
const getUrl = (itemData: ImageRendererProps['data']) => {
  if (itemData.uri) {
    return itemData.uri;
  }
  return Array.isArray(itemData.mediaUrl)
    ? itemData.mediaUrl[0].url
    : itemData.mediaUrl;
};
export const FastGalleryImageRenderer = (
  props: FastGalleryImageRendererProps,
) => {
  const { itemData } = props;
  const { selectors, data } = itemData;
  const { metaData } = data;
  const { focalPoint } = metaData;
  return (
    <div
      className={classNames(styles.imageContainer)}
      style={
        {
          // wow-image uses this trick with aspect-ratio to handle responsive auto height in studio
          '--aspect-ratio': metaData.height / metaData.width,
        } as React.CSSProperties
      }
    >
      <div className={classNames(styles.imageWrapper)}>
        <Image
          className={selectors?.image}
          uri={getUrl(data)}
          width={metaData.width}
          height={metaData.height}
          displayMode="fill"
          alt={metaData.alt}
          name={metaData.title}
          focalPoint={getFocalPoint(focalPoint)}
        />
      </div>
    </div>
  );
};
